import { ChangeDetectorRef, Component, inject, signal, ViewChild } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { StyleguideDialogComponent } from './styleguide-dialog/styleguide-dialog.component';
import { select, Store } from '@ngxs/store';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppSelectors } from '../../app.state';
import { getEditorRoleViewValue } from '../../editor/editor.role.enum';
import { DatePipe } from '@angular/common';
import { TableLoadingSpinnerComponent } from '../../utils/component/table-loading-spinner/table-loading-spinner';
import { EditorEntity } from '../../editor/editor.entity';

@Component({
  selector: 'pixl-styleguide',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatSortModule,
    MatTableModule,
    MatButtonToggleModule,
    MatDividerModule,
    MatCardModule,
    MatTooltipModule,
    DatePipe,
    MatSortModule,
    TableLoadingSpinnerComponent
  ],
  templateUrl: './styleguide.component.html',
  styleUrl: './styleguide.component.scss'
})
export class StyleguideComponent {
  /**
   * This file isn't organized like normal. The code is split for each
   * block. Variables and important stuff are defined for each block in itself.
   * When you copy and paste any code from here please also
   * review the imports above and make sure you use the necessary ones.
   */

  /**
   * General logic
   */
  private readonly store = inject(Store);
  iconsVisible = signal(false);
  cardsVisible = signal(false);
  fieldsVisible = signal(false);
  buttonsVisible = signal(false);
  tableVisible = signal(false);
  tableSpinnerVisible = signal(false);
  dialogVisible = signal(false);

  /**
   * Logic for card
   */
  public cardHeadline = 'Karte';
  public cardBody = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis saepe minus consectetur, ratione porro earum nihil dolores quo.';

  /**
   * Logic for fields
   */
  // Combobox
  public comboBoxValues: string[] = ['Wert1', 'Wert2', 'Wert3', 'Wert4', 'Wert5'];
  private value = '';

  public onComboboxChangeEvent(event: string): void {
    // this is here just so something happens here :)
    this.value = event + 'hallo';
  }

  // Inputfield
  fb = inject(FormBuilder);
  inputFieldValue = '';

  userForm = this.fb.group({
    input: [this.inputFieldValue, [Validators.required]],
  });

  /**
   * Logic for buttons
   */
  public buttonclick() {
    // this is here just so something happens here :)
    this.value = this.value + 'click';
  }

  /**
   * Logic for table
   *
   * This shown table is no template on how to implement a new table. For that refer to the other,
   * already productively used ones. This should only serve as a visual guide on how a table should
   * look in general.
   */
  @ViewChild(MatSort) sort!: MatSort;
  public displayedColumns: string[] = ['edit-actions', 'id', 'email', 'role', 'updated', 'array'];

  public appState = select(AppSelectors.appState);
  public dataSource = new MatTableDataSource<EditorEntity>([
    {
      id: '1',
      email: 'max.mustermann@example.com',
      password: 'dummy123',
      role: 'author',
      subjects: [],
      consumerIds: ['1', '2'],
      updated: new Date('2026-10-15T10:30:00'),
      version: 1
    },
    {
      id: '2',
      email: 'anna.schmidt@example.com',
      password: 'dummy456',
      role: 'editor',
      subjects: [],
      consumerIds: ['1'],
      updated: new Date('2026-10-16T14:45:00'),
      version: 3
    },
    {
      id: '3',
      email: 'peter.mueller@example.com',
      password: 'dummy789',
      role: 'appAdmin',
      subjects: [],
      consumerIds: [],
      updated: new Date('2026-10-17T08:15:00'),
      version: 2
    },
    {
      id: '4',
      email: 'lisa.weber@example.com',
      password: 'test123',
      role: 'zavAdmin',
      subjects: [],
      consumerIds: ['1', '2', '3'],
      updated: new Date('2026-10-18T16:20:00'),
      version: 5
    },
    {
      id: '5',
      email: 'tim.fischer@example.com',
      password: 'test456',
      role: 'author',
      subjects: [],
      consumerIds: ['1'],
      updated: new Date('2026-10-19T09:00:00'),
      version: 1
    },
    {
      id: '6',
      email: 'sarah.becker@example.com',
      password: 'test789',
      role: 'author',
      subjects: [],
      consumerIds: ['1', '2'],
      updated: undefined,
      version: undefined
    }
  ]);

  getArray(): string[] {
    return [
      'hallo',
      'halisdufslo',
      'hsefallo',
      'hasdfsllo',
      'hasdfsdallo',
      'haasdfjllo',
      'haerzerllo',
      'hwerwsvallo'
    ];
  }

  protected readonly getEditorRoleViewValue = getEditorRoleViewValue;

  /**
   * Logic for dialog
   */
  private dialog = inject(MatDialog);
  public cdr = inject(ChangeDetectorRef);

  openDialog(): void {
    this.dialog.open<StyleguideDialogComponent>(StyleguideDialogComponent, {
      minWidth: '40vw'
    });
  }
}
